import { Landmark, RefreshCw } from "lucide-react";
import { useQbBankBalance } from "../../hooks/useQbBankBalance";
import { formatUSD } from "../../lib/formatters";

// Compact card showing the current Cash in Bank from QuickBooks Online.
// Hidden if QB isn't connected, so it doesn't add clutter for users who
// haven't set up the integration.
export default function QbBalanceCard() {
  const { connected, totalBankBalance, accounts, fetchedAt, loading, error, refresh } = useQbBankBalance();

  if (connected === false) return null; // hide if QB not connected
  if (connected === null && loading) {
    return (
      <div className="bg-white dark:bg-[var(--bg-surface)] rounded-xl border border-gray-100 dark:border-[var(--border-soft)] px-4 py-3">
        <div className="text-[10px] uppercase tracking-wider text-brand-slate font-medium">Cash in bank</div>
        <div className="font-display font-semibold text-lg text-brand-slate mt-0.5">Loading…</div>
      </div>
    );
  }

  return (
    <div className="bg-white dark:bg-[var(--bg-surface)] rounded-xl border border-gray-100 dark:border-[var(--border-soft)] p-4">
      <div className="flex items-start justify-between">
        <div className="flex items-center gap-2">
          <Landmark size={14} className="text-brand-blue" />
          <div className="text-[10px] uppercase tracking-wider text-brand-slate font-medium">Cash in bank</div>
        </div>
        <button
          onClick={refresh}
          disabled={loading}
          title={fetchedAt ? `Last refreshed ${new Date(fetchedAt).toLocaleString()}` : "Refresh from QuickBooks"}
          className="p-1 rounded hover:bg-gray-100 dark:hover:bg-[var(--bg-soft)] text-brand-slate"
        >
          <RefreshCw size={12} className={loading ? "animate-spin" : ""} />
        </button>
      </div>
      <div className="font-display font-semibold text-2xl text-brand-ink dark:text-[var(--text-primary)] mt-1">
        {formatUSD(totalBankBalance, { decimals: 2 })}
      </div>
      {accounts.length > 0 && (
        <div className="mt-2 space-y-0.5">
          {accounts.map((a) => (
            <div key={a.id} className="flex items-center justify-between text-xs">
              <span className="text-brand-slate truncate">{a.name}</span>
              <span className="text-brand-ink dark:text-[var(--text-primary)] font-medium ml-2 whitespace-nowrap">
                {formatUSD(a.currentBalance, { decimals: 2 })}
              </span>
            </div>
          ))}
        </div>
      )}
      {error && (
        <div className="text-xs text-red-600 mt-2 break-words">{error}</div>
      )}
    </div>
  );
}